import React, { useState, useEffect } from 'react';

import './index.scss';

function ColumnsCountInput(props) {

  const [columnsCount, setColumnsCount] = useState(props.value);

  useEffect(function onValueChange() {

    setColumnsCount(props.value);

  }, [props.value]);

  function handleColumnsCountInputChange(event) {

    const value = event.target.value;

    setColumnsCount(value);

    const _columnsCount = +value;

    if (isNaN(_columnsCount)) {
      return;
    }

    if (_columnsCount === 0 || _columnsCount > 10) {
      return;
    }

    props.onChange(_columnsCount);

  }

  function renderMain() {

    const inputAttributes = {
      type: 'text',
      placeholder: 'Count between 1 to 10',
      value: columnsCount,
      onChange: handleColumnsCountInputChange
    };

    return <div className="columns-count-main">

      <input {...inputAttributes} />

    </div>;
  }

  return renderMain();
}

export default ColumnsCountInput;